import script from "./DownloadStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadStats.vue?vue&type=script&setup=true&lang=js"

import "./DownloadStats.vue?vue&type=style&index=0&id=c76bd2d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c76bd2d0"]])

export default __exports__